import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import PsychList from "../pages/Residential/Phase-03/PsychiatristOrder/PsychList";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
    fetchPsychiatricForms,
    deletePsychiatricForm,
} from "../store/slices/psychiatricFormSlice";

const Psychiatrists = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { psychiatricForms, isLoading } = useSelector(
        (state) => state.psychiatricForm
    );

    useEffect(() => {
        dispatch(fetchPsychiatricForms());
    }, [dispatch]);

    const handleAdd = () => navigate("/phase03/psychiatrist-order/add");

    const handleEdit = (id) => {
        navigate(`/phase03/psychiatrist-order/edit/${id}`);
    };

    const handleDelete = async (id) => {
        await dispatch(deletePsychiatricForm(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <PsychList
                            records={psychiatricForms}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Psychiatrists;
